"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
Object.defineProperty(exports, "__esModule", { value: true });
var Constants_1 = require("../common/Constants");
var uuid_1 = require("../utils/uuid");
var RequestHelper = /** @class */ (function () {
    function RequestHelper() {
    }
    RequestHelper.getDefaultIC3Headers = function () {
        return {
            Accept: Constants_1.default.ContentTypeJson,
            BehaviorOverride: Constants_1.default.RedirectAs404,
            ClientInfo: Constants_1.default.ClientInfoValue,
            ContextId: "tcid=".concat((0, uuid_1.uuidv4)()),
            Expires: 0,
            Pragma: Constants_1.default.NoCache,
            "x-ms-client-type": Constants_1.default.Web,
            "x-ms-user-type": Constants_1.default.User
        };
    };
    RequestHelper.getDefaultBaseIC3Headers = function () {
        return {
            Accept: Constants_1.default.ContentTypeJson,
            BehaviorOverride: Constants_1.default.RedirectAs404,
            "content-type": Constants_1.default.ContentTypeJson
        };
    };
    RequestHelper.getDefaultGetMessagesQueryParameters = function () {
        return {
            pageSize: 20,
            startTime: 0,
            view: "msnp24Equivalent|supportsMessageProperties"
        };
    };
    RequestHelper.getDefaultAMSHeaders = function (token) {
        return {
            Authorization: Constants_1.default.AMSAuthorizationSkypeTokenValue + token,
            "X-MS-Client-Version": Constants_1.default.ClientInfoValue
        };
    };
    RequestHelper.getDefaultAMSViewHeaders = function (token) {
        return {
            Accept: Constants_1.default.AMSAcceptHeaderValue,
            "Accept-Encoding": Constants_1.default.AMSAcceptEncodingHeaderValue,
            Authorization: Constants_1.default.AMSAuthorizationSkypeTokenValue + token,
            "X-MS-Client-Version": Constants_1.default.ClientInfoValue
        };
    };
    return RequestHelper;
}());
exports.default = RequestHelper;
//# sourceMappingURL=RequestHelper.js.map